export enum TabId {
  INQUIRY = 'prospect-inquiry',
}

export interface FormInquiryResponse {
  enrollmentUrl: string;
}
